import { useCallback } from 'react';

import { useFeatureFlagEnabled } from 'posthog-js/react';

import { GX_EXPORT_VIDEO_EXPLAINER } from '@/constants/featureFlags';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { useImpersonatorEmailFromStorage } from '@/services/storage';
import { markExplainerVideoSeen } from '@/slices/userConfigSlice';

export const useExplainerVideoModal = () => {
  const dispatch = useAppDispatch();
  const isFeatureEnabled = useFeatureFlagEnabled(GX_EXPORT_VIDEO_EXPLAINER);
  const tripTokenStatus = useAppSelector(state => state.tripToken.status);
  const configStatus = useAppSelector(state => state.userConfig.status);
  const exportVideoExplainerSeen = useAppSelector(
    state => state.userConfig.userConfig.exportVideoExplainerSeen
  );
  const impersonatorEmail = useImpersonatorEmailFromStorage();

  const isOpen =
    isFeatureEnabled === true &&
    tripTokenStatus === 'fulfilled' &&
    configStatus === 'fulfilled' &&
    !impersonatorEmail &&
    !exportVideoExplainerSeen;

  const onDismiss = useCallback(() => {
    dispatch(markExplainerVideoSeen());
  }, [dispatch]);

  return { isOpen, onDismiss };
};
